import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IndexGaugeService } from './index-gauge.service';
import { ECharts, EChartOption } from 'echarts';
import { initOpts } from '../../config/initOpts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChartResizeService } from '../../service/chart-resize.service';
import { CommonService } from '../../service/common.service';
import { ChartOptionService } from '../../service/chart-option.service';

@Component({
  selector: 'bcac-index-gauge',
  templateUrl: './index-gauge.component.html',
  styleUrls: ['./index-gauge.component.scss']
})
export class IndexGaugeComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private indexGaugeService: IndexGaugeService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  }


  // 布局设置
  // cardpadding
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = "";

  // echarts 图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  // chartVisualMap = this.multiDimensionBarService.getPiecewiseVisualMap();
  gaugeChartSeries: EChartOption.SeriesGauge = this.indexGaugeService.getDefaultGaugeService();
  // chartTooltip: EChartOption.Tooltip = this.multiDimensionBarService.getAxisChartWithMultiDimensionTooltip();
  chartTooltip: EChartOption.Tooltip = this.chartOptionService.getTooltipOfIndexGauge();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    tooltip: this.chartTooltip,
    series: this.chartSeriesList
  }

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;

  onOptionInit(ec) {
    this.optionInit = ec;
  }


  options;
  // echarts配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }

  // Input 输入区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.indexGaugeService.changeChartTitleDark(this, darkMode);
    this.indexGaugeService.chartBackgroundColorDarkMode(this.chartOption);
    this.indexGaugeService.colorsDarkMode(this.chartColors);
    this.indexGaugeService.seriesDarkMode(this.gaugeChartSeries);
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.indexGaugeService.setSmallModePadding(this);
    }
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.indexGaugeService.chartColorsChange(this.chartColors, colorList);
  }

  @Input()
  set bcacMin(min: number) {
    this.indexGaugeService.setSeriesMin(this.gaugeChartSeries, min);
  }

  @Input()
  set bcacMax(max: number) {
    this.indexGaugeService.setSeriesMax(this.gaugeChartSeries, max);
  }

  @Input()
  set bcacSplitLineSwitch(splitLine: boolean) {
    this.indexGaugeService.setSplitLine(this.gaugeChartSeries, splitLine)
  }

  @Input()
  set bcacAxisTickSwitch(axisTick: boolean) {
    this.indexGaugeService.setAxisTick(this.gaugeChartSeries, axisTick)
  }


  @Input()
  set bcacChartData(chartData: any) {
    if (chartData) {
      this.indexGaugeService.buildSeries(chartData, this.chartSeriesList, this.gaugeChartSeries);
      this.updateOption();
    }
  }


  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }


  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacDetailText(detailText: { number: string, unit: string, itemText: string }) {
    this.indexGaugeService.setDetailText(detailText, this.gaugeChartSeries, this.chartTooltip);
  }

  @Input()
  set bcacSplitNum(splitNum) {
    this.indexGaugeService.setSplitNumber(this.gaugeChartSeries, splitNum);
  }


  @Input()
  set bcacColorRange(colorRange: any) {
    this.indexGaugeService.setColorRange(this.gaugeChartSeries, colorRange);
  }

  @Input()
  set bcacLabelSwitch(labelSwitch: boolean) {
    this.indexGaugeService.setAxisLabel(this.gaugeChartSeries, labelSwitch);
  }

  @Input()
  set bcacRadius(radius) {
    this.indexGaugeService.setRadius(this.gaugeChartSeries, radius);
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdaptGauge(this.optionInit, this.options)
    })

  }








}
